import { API_URL, setHeader } from 'api';
import axios from 'axios';

const URL = `${API_URL}/vendor-requests`;

export const fetchVendor = id => {
  const req = setHeader(axios);
  return req.get(`${URL}/vendors/${id}`);
};

export const createVendor = params => {
  const req = setHeader(axios);
  return req.post(`${API_URL}/vendors`, { params });
};

export const mergeVendors = (sourceVendorID, destinationVendorID) => {
  const req = setHeader(axios);
  return req.put(`${API_URL}/vendor-requests/vendors/merge`, {
    sourceVendorID,
    destinationVendorID,
  });
};

export const fetchAllVendorsManagement = params => {
  const req = setHeader(axios);
  return req.get(`${URL}/vendors/management`, { params });
};
